<div
	class="flex place-self-stretch flex-1 justify-center items-center bg-gray-50"
>
	<img
		src="/assets/images/undraw/undraw_welcoming_leap.svg"
		class="max-w-250 w-full"
	/>
</div>

<div class="flex flex-col gap-6 p-6">
	<div>
		<h5>Select the type of matter</h5>
		<p class="p-sm">
			A matter consists of all information, tasks and documentation needed to
			complete a single real estate transaction from start to finish.
		</p>
	</div>
	<div class="w-full flex gap-2.5">
		<div
			*ngFor="let fileType of fileTypes"
			[class]="
				'file-select__matter-option file-select__matter-option--' + fileType
			"
			(click)="setFileType(fileType)"
			tabindex="0"
			[testHook]="testHooks.SetFileTypeDiv"
		>
			{{ fileType | capitalize }}
		</div>
	</div>
	<ui-note title="Note" [testHook]="testHooks.Note">
		<p class="p-sm">
			Once a matter type is selected, it can't be changed later.
		</p>
	</ui-note>
</div>
